export default class {
  constructor (obj, currentCamping) {
    this.name = obj.name
    this.isGroup = obj.isGroup
    this.campings = obj.campings
    this.currentCamping = null
    this.report = obj.report
    if (!this.isGroup) {
      this.currentCamping = this.campings[0]
    } else if (currentCamping !== null) {
      this.currentCamping = currentCamping
    }
  }

  // Retourne le nom du compte à affiche
  get fullName () {
    let name = this.name
    if (this.isGroup && this.currentCamping !== null) {
      name += ' / ' + this.currentCamping.name
    }
    return name
  }
}
